import { siteConfig } from "../config/site";

export default function OtherSongs() {
  const { otherSongs } = siteConfig;
  const first = otherSongs[0];

  return (
    <section
      id="other-songs"
      data-testid="other-songs-section"
      className="relative py-24 sm:py-32"
    >
      <div className="mx-auto max-w-5xl px-6 sm:px-10 text-center">
        <span className="inline-block text-[0.7rem] tracking-[0.35em] uppercase text-[color:var(--yicel-violet)] font-semibold">
          Otras canciones
        </span>
        <h2 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl text-ink"
            data-testid="other-songs-title">
          {first.title}
        </h2>
        <p className="mt-5 max-w-lg mx-auto text-base sm:text-lg text-[color:var(--yicel-muted)]">
          {first.description}
        </p>

        <div className="mt-12 glass rounded-3xl p-3 sm:p-4 shadow-[0_30px_60px_-30px_rgba(178,164,255,0.5)]">
          <div className="relative aspect-video rounded-2xl overflow-hidden bg-black/5">
            <iframe
              data-testid="other-songs-youtube"
              title={first.title}
              src={first.youtubeEmbed}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="absolute inset-0 w-full h-full"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
